export const REDUCER_NAME = "competitionTable";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONTABLE = `${REDUCER_NAME}/SET_COMPETITIONTABLE`;
export const RESET_COMPETITIONTABLE = `${REDUCER_NAME}/RESET_COMPETITIONTABLE`;
